module.exports = __webpack_public_path__ + "static/media/medicoteste.3ab13901.png";